export var isRow = function (node) {
    return node ? Object.prototype.hasOwnProperty.call(node, 'cells') : false;
};
//# sourceMappingURL=node.js.map